module.exports = __webpack_public_path__ + "assets/img/wangjing.4d3f2ce3.png";